import {PureComponent} from 'react'

import DashboardLayout from '../../../../Layout/DashboardLayout.jsx'
import Navbar from '../../../../Navbar/Navbar.jsx'

import Alert from "../../../../../../shared/components/Dashboard/Alert.jsx"
import BringBusiness from "../../../../../../shared/components/Dashboard/BringBusiness.jsx"
import FreelanceAgent from "../../../../../../shared/components/Dashboard/FreelanceAgent.jsx"
import FreelanceAvailability from "../../../../../../shared/components/Dashboard/FreelanceAvailability.jsx"
import Partnership from "../../../../../../shared/components/Dashboard/Partnership.jsx"
import Positioning from "../../../../../../shared/components/Dashboard/Positioning.jsx"

import conf from "../../../../../conf.js"
import api from "../../../../../../api.js"
import {generate} from "../../../../../routes.js"

export default class UserDashboard extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      emailSelected: false,
      smsSelected: false,
      agent: {
        linkedin_url: undefined,
        fullname: undefined,
        email: undefined,
        tel: undefined,
        image: undefined,
      },
    }
  }

  async componentDidMount() {
    const { currentUser, profile } = this.props

    await this.loadUserData(currentUser)

    if (profile?.freelance) {
      await this.loadFreelanceAgent(profile.freelance)
    }
  }

  loadUserData = async (user) => {
    try {
      const alertsOffers = (await api.alertsOffers.getAll({
        user: user.id
      })).data

      if (alertsOffers.length > 0) {
        const alertOffers = alertsOffers[0]

        this.setState(() => ({
          emailSelected: !!(alertOffers.channel & conf.alert.channels.email.value),
          smsSelected: !!(alertOffers.channel & conf.alert.channels.sms.value),
        }))
      }
    } catch (error) {
      console.error("Erreur lors du chargement des alertes :", error)
    }
  }

  loadFreelanceAgent = async (freelance) => {
    try {
      const response = await api.freelances.getMyAgent({
        freelance: freelance.id
      })

      if (response?.status === 200 && response.data) {
        this.setState({ agent: response?.data })
      }
    } catch (error) {
      console.error("Erreur lors du chargement de l'agent freelance :", error)
    }
  }

  getFreelancePositionings = () => {
    const { profile } = this.props
    return ((profile?.freelance?.positionings) ?? []).slice(0, 4)
  }

  render() {
    const { link, profile } = this.props
    const { emailSelected, smsSelected } = this.state

    return (
      <DashboardLayout navbar={this.props.navbar ? <Navbar locked={true} /> : null}>
        <div className="page-background print-no-color">
          <div className="container container-profile-freelance">
            <div className="row">
              <div className="dashboard-row">
                <div className="dashboard-col">
                  <FreelanceAvailability
                    generate={generate}
                    conf={conf}
                    onSubmit={() => {}}
                    link={link}
                    user={profile?.user ?? {}}
                    freelance={profile?.freelance ?? { date_avalaible: null }}
                  />
                </div>
                <div className="dashboard-col">
                  <FreelanceAgent generate={generate} conf={conf} agent={this.state.agent}/>
                </div>
              </div>
              <div className="dashboard-row">
                <div className="dashboard-col">
                  <Positioning generate={generate} conf={conf} link={link} positionings={this.getFreelancePositionings()} />
                </div>
                <div className="dashboard-col">
                  <Alert generate={generate} conf={conf} emailSelected={emailSelected} smsSelected={smsSelected} link={link} />
                  <BringBusiness generate={generate} conf={conf} />
                </div>
              </div>
              <Partnership generate={generate} conf={conf} />
            </div>
          </div>
        </div>
      </DashboardLayout>
    )
  }
}
